class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    const closeButton =
      this.querySelector('.search-modal__close-button, .modal__close-button[type="button"]') ||
      this.querySelector('button[type="button"].modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (document.body.classList.contains('template-collection')) {
      const modalContent = this.querySelector('.modal__content');
      if (modalContent) {
        requestAnimationFrame(() => {
          const sectionHeader = document.querySelector('.section-header');

          let headerHeight = 0;

          if (sectionHeader) {
            headerHeight = sectionHeader.offsetHeight;
          } else {
            const headerWrapper = document.querySelector('.header-wrapper');
            const announcementBar = document.querySelector('.announcement-bar-section');

            if (announcementBar) {
              headerHeight += announcementBar.offsetHeight;
            }

            if (headerWrapper) {
              headerHeight += headerWrapper.offsetHeight;
            } else {
              const header = document.querySelector('.header');
              if (header) {
                headerHeight += header.offsetHeight;
              }
            }
          }

          if (headerHeight > 0) {
            modalContent.style.setProperty('top', `${headerHeight}px`, 'important');
          }
        });
      }
    }

    // trapFocus(
    //   this.detailsContainer.querySelector('[tabindex="-1"]'),
    //   this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );
  }

  close(focusToggle = true) {
    // removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
